import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';
import { silentHttpErrorContext } from '@shared/http';
import { PaginatedResponse } from '@shared/models';
import {
  ConversationThreadDto,
  ConversationDetailDto,
  ConversationFilter,
  UnreadCountResponse,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class ConversationsApiService {
  private readonly apiUrl = `${environment.apiUrl}conversations`;
  private readonly presenceUrl = `${environment.apiUrl}chat-presence`;
  private readonly http = inject(HttpClient);

  getThreads(filter: ConversationFilter = {}): Observable<PaginatedResponse<ConversationThreadDto>> {
    let params = new HttpParams();
    if (filter.status) params = params.set('status', filter.status);
    if (filter.search) params = params.set('search', filter.search);
    if (filter.propertyId !== undefined) params = params.set('propertyId', filter.propertyId.toString());
    if (filter.page !== undefined) params = params.set('page', filter.page.toString());
    if (filter.limit !== undefined) params = params.set('limit', filter.limit.toString());

    return this.http.get<PaginatedResponse<ConversationThreadDto>>(this.apiUrl, { params });
  }

  getThread(threadId: string, before?: string): Observable<ConversationDetailDto> {
    let params = new HttpParams();
    if (before) params = params.set('before', before);
    return this.http.get<ConversationDetailDto>(`${this.apiUrl}/${threadId}`, { params });
  }

  reply(threadId: string, message: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${threadId}/reply`, { message });
  }

  close(threadId: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${threadId}/close`, {});
  }

  markAsRead(threadId: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${threadId}/read`, {});
  }

  /** Send typing indicator for host */
  sendTyping(threadId: string): Observable<void> {
    return this.http.post<void>(`${this.presenceUrl}/typing`, { threadId });
  }

  /**
   * Get unread message counts.
   * Zapytanie w tle (SseNotificationService po zalogowaniu i każdym reconnect SSE) — bez globalnego
   * toasta błędu: sesja gościa (rola spoza USER/ADMIN/SUPER_ADMIN) i konto bez aktywnej organizacji
   * dostają tu 403.
   */
  getUnreadCount(): Observable<UnreadCountResponse> {
    return this.http.get<UnreadCountResponse>(`${this.presenceUrl}/unread-count`, {
      context: silentHttpErrorContext(),
    });
  }
}
